import { useTranslation } from "react-i18next";
import ActionButtonLayout from "./ActionButtonLayout";
import AttachFileIcon from '@material-ui/icons/AttachFile';

/**
 * @COMPONENT_NAME FileHistoryButtonLayout
 * @DESCRIPTION 다국어 버튼명을 포함한 액션 버튼 레이아웃 컴포넌트.
 *              buttonName을 i18n 번역 후 ActionButtonLayout의 자식으로 렌더링합니다.
 *
 * @PROPS
 *   - {...any} others - ActionButtonLayout에 전달될 기타 props
 *
 * @PASSTHROUGH_PROPS
 *   - {any} * - 모든 props는 ActionButtonLayout으로 전달됩니다.
 *   - {SvgIcon: OverridableComponent<SvgIconTypeMap>} startIcon - <AttachFileIcon /> 전달
 * @CALLBACKS 없음
 *
 * @EXAMPLES
 * ```jsx
 * <FileHistoryButtonLayout onClick={() => openDialog()} />
 * ```
 */

function FileHistoryButtonLayout ( props ) {

    const { t } = useTranslation();

    const { ...others } = props;

    return (

      <ActionButtonLayout
        startIcon={<AttachFileIcon />}

        {...others}
      >
        { t ( "buttonName.fileHistory" ) }
      </ActionButtonLayout>

    );
}

export default FileHistoryButtonLayout;

